import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "decrementForm", "incrementForm"]

  increment() {
    if (this.buttonTarget.disabled) {
      return
    }

    this.incrementFormTarget.requestSubmit()
  }

  decrement() {
    if (this.buttonTarget.disabled) {
      return
    }

    this.decrementFormTarget.requestSubmit()
  }
}
